<div class="container-fluid mt-2">
  <form
    *ngIf="formGroup"
    [formGroup]="formGroup"
    (keydown.enter)="$event.preventDefault()"
  >
    <div class="row">
      <div class="col-md-12 col-lg-8">
        <h5 id="Section1Title">Description of Work</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-lg-3">
        <mat-form-field
          [ngClass]="{
            hilite:
              rsswa &&
              status?.isViewingAmendment &&
              estInitCtrl.value != rsswa.startOn,
          }"
        >
          <mat-label>Estimate Start Date</mat-label>
          <input
            matInput
            [matDatepicker]="startDate"
            placeholder="Estimate Start Date"
            name="startDate"
            (dateChange)="addEvent()"
            formControlName="estInitCtrl"
          />
          <mat-datepicker-toggle
            class="d-print-none"
            matSuffix
            [for]="startDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>
          <mat-error *ngIf="estInitCtrl.invalid">{{
            getErrorMsg(estInitCtrl)
          }}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-6 col-lg-3">
        <mat-form-field
          [ngClass]="{
            hilite:
              rsswa &&
              status?.isViewingAmendment &&
              estEndCtrl.value != rsswa.completeOn,
          }"
        >
          <mat-label>Estimate Completion Date</mat-label>
          <input
            matInput
            [matDatepicker]="endDate"
            placeholder="Estimate Completion Date"
            name="endDate"
            formControlName="estEndCtrl"
          />
          <mat-datepicker-toggle
            class="d-print-none"
            matSuffix
            [for]="endDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDate></mat-datepicker>
          <mat-error *ngIf="estEndCtrl.invalid">{{
            getErrorMsg(estEndCtrl)
          }}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12 col-lg-6">
        <mat-form-field
          [ngClass]="{
            hilite:
              rsswa &&
              status?.isViewingAmendment &&
              requesterCtrl.value?.id != rsswa.requesterId,
          }"
        >
          <mat-label>Requester</mat-label>
          <input
            matInput
            placeholder="Requester"
            aria-label="Requester"
            [matAutocomplete]="reqAuto"
            formControlName="requesterCtrl"
            name="Requester"
            (keyup)="onReqChange($event.code)"
            #trigger="matAutocompleteTrigger"
          />
          <mat-autocomplete
            #reqAuto="matAutocomplete"
            [displayWith]="displayObject"
            (optionSelected)="selectedReq($event)"
            (closed)="onClosedReq()"
          >
            <mat-option [value]="user" *ngFor="let user of requesters">
              <div class="d-flex full-width">
                <span class="mr-2">{{ user.name }}</span>
                <role-chips
                  [roleCodes]="getRoleCodes(user)"
                  [disabled]="true"
                ></role-chips>
              </div>
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="requesterCtrl?.invalid">{{
            getErrorMsg(requesterCtrl)
          }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <!-- Related Documents -->
        <related-documents
          [relatedDocuments]="documents"
          [formID]="rsswa?.id"
          [formType]="formTypeEnum.RSSWA"
          [includeDrafts]="true"
          [disabled]="disabled"
          (changed)="documents = $event; setFormDirty()"
          [hilite]="status?.isViewingAmendment && diffRelatedDocuments()"
          [control]="documentCtrl"
          [disableTooltips]="true"
        ></related-documents>
      </div>

      <div class="col-12 col-lg-4">
        <mat-form-field
          appearance="outline"
          [ngClass]="{
            hilite: rsswa && status?.isViewingAmendment && diffWorkPerformers(),
          }"
        >
          <mat-label>Group(s) Performing Work</mat-label>
          <mat-chip-grid
            #chipListPer
            aria-label="Workers selection"
            [formControl]="performerCtrl"
          >
            <mat-chip-row
              *ngFor="let performer of workPerformers"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removePer(performer)"
            >
              {{ performer.name + " (" + performer.code + ")" }}
              <mat-icon matChipRemove *ngIf="!disabled">cancel</mat-icon>
            </mat-chip-row>
            <input
              placeholder="Group(s) / Person(s) Performing Work"
              #performerInput
              [matAutocomplete]="autoPer"
              [matChipInputFor]="chipListPer"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="addPer($event)"
              formControlName="performerCtrl"
              (keyup)="onPerChange($event.code)"
            />
          </mat-chip-grid>
          <mat-autocomplete
            #autoPer="matAutocomplete"
            (optionSelected)="selectedPer($event)"
          >
            <mat-optgroup
              *ngFor="let group of filteredPerformerGroups"
              [label]="group.name"
            >
              <mat-option
                *ngFor="let performer of group.workPerformers"
                [value]="performer"
              >
                {{ performer.name + " (" + performer.code + ")" }}
              </mat-option>
            </mat-optgroup>
          </mat-autocomplete>
          <mat-error *ngIf="performerCtrl?.invalid">{{
            getErrorMsg(performerCtrl)
          }}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4"></div>
    </div>

    <fieldset
      class="field-group"
      [disabled]="disabled"
      [ngClass]="{
        disabled: disabled,
        hilite:
          rsswa &&
          status?.isViewingAmendment &&
          rsswa.beamLine != chkBeamlineCtrl.value,
        invalid: systemsAffectedError,
      }"
    >
      <legend>Systems Affected</legend>
      <div class="row d-flex justify-content-between">
        <div class="d-flex flex-column col-3">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.beamLine != chkBeamlineCtrl.value,
            }"
            formControlName="chkBeamlineCtrl"
            (change)="systemChanged()"
            class="d-block mb-1"
            >Beamline</mat-checkbox
          >
          <resource-chips
            [selectedResources]="getResources(tmpRsswaShutters)"
            [resourceTypes]="[
              resourceTypeEnum.Shutter,
              resourceTypeEnum.Branchline,
            ]"
            [placeholder]="'Beamline Locations'"
            [disabled]="!(!disabled && chkBeamlineCtrl.value)"
            [control]="rsswaShuttersControl"
            (onEdit)="onRsswaShuttersEdited($event)"
            (onError)="showAlert($event)"
            [hilite]="status?.isViewingAmendment && diffShutters()"
          >
          </resource-chips>
        </div>
        <div class="d-flex flex-column col-3">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.accelerator != chkAcceleratorCtrl.value,
            }"
            formControlName="chkAcceleratorCtrl"
            (change)="systemChanged()"
            class="d-block mb-1"
            >Accelerator</mat-checkbox
          >
          <resource-chips
            [selectedResources]="getResources(tmpRsswaAcceleratorLocations)"
            [resourceTypes]="[
              resourceTypeEnum.Accelerator,
              resourceTypeEnum.AcceleratorLocation,
            ]"
            [placeholder]="'Accelerator Locations'"
            [disabled]="!(!disabled && chkAcceleratorCtrl.value)"
            [control]="rsswaAcceleratorLocationsControl"
            (onEdit)="onRsswaAcceleratorLocationsEdited($event)"
            (onError)="showAlert($event)"
            [hilite]="status?.isViewingAmendment && diffAccelerators()"
          ></resource-chips>
        </div>
        <div class="d-flex flex-column col-3">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.topOff != chkTopOffCtrl.value,
            }"
            formControlName="chkTopOffCtrl"
            (change)="systemChanged()"
            class="d-block mb-1"
            >Top-off</mat-checkbox
          >
          <rsswa-other-system-chips
            [placeholder]="'Other systems'"
            [disabled]="disabled"
            [control]="rsswaOtherSystemsControl"
            [rsswaId]="rsswa?.id"
            [rsswaOtherSystems]="tmpRsswaOtherSystems"
            (onEdit)="onRsswaOtherSystemsEdited($event)"
            [hilite]="status?.isViewingAmendment && diffOtherSystems()"
          >
          </rsswa-other-system-chips>
        </div>
        <div class="d-flex flex-column col-3">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.radiationMonitoringSystem != chkRadMonitorCtrl.value,
            }"
            formControlName="chkRadMonitorCtrl"
            (change)="systemChanged()"
            class="d-block mb-1"
            >Radiation Monitoring System</mat-checkbox
          >
        </div>
      </div>
    </fieldset>

    <div class="row py-2 px-3">
      <div class="col-md-6 col-lg-4 col-xl-2 p-1">
        <div class="check-card check-disabled" id="chkRSSPLCSetCtrl">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.rssplcSet != chkRSSPLCSetCtrl.value,
            }"
            formControlName="chkRSSPLCSetCtrl"
            >PPS PLC Set Pt / Parameter Access
          </mat-checkbox>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-2 p-1">
        <div class="check-card check-disabled" id="chkRSSSoftwareCtrl">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.rssSoftware != chkRSSSoftwareCtrl.value,
            }"
            formControlName="chkRSSSoftwareCtrl"
            (change)="setFormDirty()"
            >PPS Software / Firmware Download
          </mat-checkbox>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-2 p-1">
        <div class="check-card check-disabled" id="chkETIAccessCtrl">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.etiAccess != chkETIAccessCtrl.value,
            }"
            formControlName="chkETIAccessCtrl"
            >ETI Access / TOMBIS Modification / TOMBIS Removal of Components
          </mat-checkbox>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-2 p-1">
        <div class="check-card check-disabled" id="chkTPLSetCtrl">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.tombisplcSet != chkTPLSetCtrl.value,
            }"
            formControlName="chkTPLSetCtrl"
            >TOMBIS PLC Set Pt / Parameter Access
          </mat-checkbox>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-2 p-1">
        <div class="check-card check-disabled" id="chkTSoftwareCtrl">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.tombisSoftware != chkTSoftwareCtrl.value,
            }"
            formControlName="chkTSoftwareCtrl"
            >TOMBIS Software / Firmware Download
          </mat-checkbox>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 col-xl-2 p-1">
        <div class="check-card check-disabled" id="chkTopOffInterlockCtrl">
          <mat-checkbox
            [ngClass]="{
              hilite:
                rsswa &&
                status?.isViewingAmendment &&
                rsswa.topOffInterlockSetPoint != chkTopOffInterlockCtrl.value,
            }"
            formControlName="chkTopOffInterlockCtrl"
            >TOP OFF Interlock set Point and/or Interlock threshold modification
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="row px-2 mt-0">
      <div class="col px-1">
        <comments-box
          title="Work Description"
          [textValue]="tmpDescription"
          [disabled]="disabled"
          formType="RSSWA"
          [serialNo]="rsswa?.serialNo"
          (textChanged)="descriptionChanged($event)"
          [hasError]="descriptionCtrl.invalid"
          [control]="descriptionCtrl"
          [hilite]="
            !!rsswa && !!status?.isViewingAmendment && diffDescription()
          "
        >
        </comments-box>
      </div>
    </div>
    <div class="row">
      <div class="col col-xl-12">
        <div class="d-print-block w-100">
          <related-link-chips
            [placeholder]="'Related Documents and Links'"
            [disabled]="disabled"
            [formId]="rsswa?.id"
            [relatedLinks]="tmpRsswaRelatedLinks"
            (onEdited)="onRelatedLinksEdited($event)"
            [hilite]="status?.isViewingAmendment && diffRelatedLinks()"
          ></related-link-chips>
        </div>
      </div>
    </div>
    <div class="w-100 d-print-block print-container">
      <h5 id="Section2Title">Work Controls</h5>
      <div class="row">
        <div class="col">
          <form-restriction-table
            [formType]="formTypeEnum.RSSWA"
            [formID]="rsswa?.id"
            [locationIDs]="tmpResourceIds"
            [formRestrictions]="tmpRsswaRestrictions"
            [disabled]="disabled"
            [customTitle]="'Required controls in place prior to work:'"
            [hilite]="status?.isViewingAmendment && diffRestrictions()"
            [control]="restrictionsControl"
            (changed)="restrictionsChanged($event)"
          ></form-restriction-table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <rsswa-section1-functional-tests
          [rsswa]="rsswa"
          [disabled]="disabled"
          [showAmendment]="status?.isViewingAmendment ?? false"
          [(chkFuncTestCtrl)]="chkFuncTestCtrl"
          [(functionalTestCtrl)]="functionalTestCtrl"
          [(provisionalTestingRequiredCtrl)]="provisionalTestingRequiredCtrl"
        ></rsswa-section1-functional-tests>
      </div>
    </div>

    <div class="row print-container mt-2">
      <div class="col-12">
        <comments-box
          title="Testing Required Before Operation (Full Test, Functional
                  Test)"
          [disabled]="disabled"
          formType="RSSWA"
          [serialNo]="rsswa?.serialNo"
          [control]="provisionalTestingRequiredCtrl"
          [textValue]="provisionalTestingRequiredCtrl.value"
          (textChanged)="provisionalTestingRequiredChanged($event)"
          [hilite]="
            !!rsswa &&
            !!status?.isViewingAmendment &&
            rsswa.provisionalTestingRequired !=
              rsswa.rsswaAmendment?.provisionalTestingRequired
          "
        ></comments-box>
      </div>
    </div>
  </form>
</div>

<div
  class="buttons d-print-none d-flex justify-content-between"
  *ngIf="
    (rsswa?.editingById == currentUser?.id ||
      showCancelNew ||
      showCancelForm ||
      showSubmit ||
      showUnSubmit) &&
    !this.status?.isLogView
  "
>
  <div class="d-flex justify-content-start">
    <!-- <button
      mat-flat-button
      *ngIf="showCancelNew"
      color="warn"
      (click)="cancel()"
    >
      Cancel
    </button> -->
    <button
      mat-flat-button
      *ngIf="showCancelNew || showCancelForm"
      color="warn"
      (click)="cancel()"
    >
      {{ status?.isViewingAmendment ? "Cancel Amendment" : "Cancel" }}
    </button>
  </div>
  <div class="d-flex justify-content-end">
    <button
      (click)="editOlog()"
      mat-stroked-button
      color="primary"
      *ngIf="
        rsswa?.status == formStatusEnum.Draft &&
        rsswa?.editingById == currentUser?.id
      "
      [disabled]="disabled"
    >
      Edit Olog
    </button>

    <button
      mat-flat-button
      type="submit"
      class="ml-2"
      *ngIf="
        rsswa?.editingById == currentUser?.id &&
        (rsswa?.status == formStatusEnum.New ||
          rsswa?.status == formStatusEnum.Draft ||
          (rsswa?.status == formStatusEnum.AmendmentDrafting &&
            status?.isViewingAmendment))
      "
      color="accent"
      (click)="saveForm(1)"
      [disabled]="formGroup.disabled || !isFormDirty() || formGroup.invalid"
    >
      {{ saveButtonText }}
    </button>

    <button
      *ngIf="rsswa?.status == formStatusEnum.WorkApprovals && showUnSubmit"
      mat-flat-button
      color="warn"
      class="ml-2"
      (click)="disapprove()"
    >
      Unsubmit
    </button>

    <button
      *ngIf="
        rsswa?.status == formStatusEnum.AmendmentApprovals &&
        hasPrivilege(privilegeEnum.RSSWACancelAmendment)
      "
      class="ml-2"
      mat-flat-button
      color="warn"
      (click)="disapprove()"
    >
      Unsubmit Amendment
    </button>
    <button
      mat-flat-button
      *ngIf="
        showSubmit &&
        rsswa?.status == formStatusEnum.Draft &&
        rsswa?.editingById == currentUser?.id
      "
      type="submit"
      class="ml-2"
      color="primary"
      (click)="saveForm(formStatusEnum.WorkApprovals)"
    >
      Submit
    </button>
    <button
      mat-flat-button
      class="ml-2"
      *ngIf="
        showSubmit &&
        rsswa?.status == formStatusEnum.AmendmentDrafting &&
        rsswa?.editingById == currentUser?.id
      "
      color="primary"
      type="submit"
      (click)="submit_amendment()"
    >
      Submit Amendment
    </button>
  </div>
</div>
